import type { GetContractBillingScheduleResponse } from '@vy/api-definition';
import { GetContractBillingScheduleResponseSchema } from '@vy/api-definition';
import type { QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

async function contractBillingScheduleQuery(contractId: string) {
  const privateApi = getPrivateApi();
  const billingSchedule = await privateApi.getContractBillingSchedule({ contractId });

  return GetContractBillingScheduleResponseSchema.parse(billingSchedule);
}

export function useContractBillingSchedule(
  contractId: string,
  options?: CustomUseQueryOptions<GetContractBillingScheduleResponse>,
) {
  return useQuery(
    queryKeys.contractBillingSchedule(contractId),
    () => contractBillingScheduleQuery(contractId),
    options,
  );
}

export async function prefetchContractBillingSchedule(contractId: string, queryClient: QueryClient) {
  await queryClient.prefetchQuery(queryKeys.contractBillingSchedule(contractId), () =>
    contractBillingScheduleQuery(contractId),
  );
}
